let blobUrlPromise: Promise<string> | null = null

export function getPlateCssBlobUrl(): Promise<string> {
  if (!blobUrlPromise) {
    blobUrlPromise = fetch('https://platejs.org/tailwind.css')
      .then(res => res.blob())
      .then(blob => URL.createObjectURL(blob))
  }

  return blobUrlPromise
}
